module.exports = __webpack_public_path__ + "static/media/paw-claws.1e9ca9ab.svg";